// ---------------------------------------------------------------------------
// Pure geo-coordinate math — zero dependency on AEMET, ROCIO, or any other
// domain concept. `LatLon`/`haversineDistanceKm` used to live inside
// aemet.ts, purely because that was the first module that needed
// nearest-station distance — but rocio.ts (a separate, unrelated grid-cell
// domain) reached into aemet.ts for the exact same helpers, and gisLayer.ts
// carried its own private, byte-for-byte duplicate `LatLon` type instead of
// importing one. Kept here, in its own module, so anything that only needs
// "distance between two lat/lon points" doesn't have to depend on the
// AEMET/series machinery to get it (same reasoning as isoDate.ts).
// ---------------------------------------------------------------------------

export interface LatLon {
  lat: number;
  lon: number;
}

export function haversineDistanceKm(a: LatLon, b: LatLon): number {
  const earthRadiusKm = 6371;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLon = ((b.lon - a.lon) * Math.PI) / 180;
  const lat1 = (a.lat * Math.PI) / 180;
  const lat2 = (b.lat * Math.PI) / 180;
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
  return 2 * earthRadiusKm * Math.asin(Math.sqrt(h));
}
